export const en = {
    close: 'Close',
    download: 'Download file',
    'error-message': 'An error occurred. Try again later.',
    'export-to-excel': 'Export to Excel',
    'pay-not-allowed-cpm':
        'To pay for display campaigns, generate a separate invoice. You cannot pay for display campaigns together with other campaigns.',
    'pay-not-allowed-deals':
        'To pay for campaigns with deals, generate a separate invoice. You cannot pay for campaigns with deals together with other campaigns.'
};
